import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import useItinerarySummary from '@/modules/Search/store/itinerarySummary'

const useCuratedTravelStore = defineStore(
  'curatedTravel',
  () => {
    const itinerarySummaryStore = useItinerarySummary()

    const curatedId = ref<string | null>(null)
    const searchId = ref<string | null>(null)
    const tierType = ref<string | null>(null)

    const curateTravelCitiesCodes = ref<string[]>([])

    const flightResultCount = ref<number | null>(null)
    const hotelResultCount = ref<number | null>(null)

    function setTierType(payload: string) {
      tierType.value = payload
    }

    function setCuratedId(payload: string) {
      curatedId.value = payload
    }

    function setSearchId(payload: string) {
      searchId.value = payload
    }

    function setCurateTravelCitiesCodes(codes: string[]) {
      curateTravelCitiesCodes.value = codes
    }

    function setFlightResultCount(count: number | null) {
      flightResultCount.value = count
    }

    function setHotelResultCount(count: number | null) {
      hotelResultCount.value = count
    }

    const isAllDataSelected = computed(() => {
      let result = true

      // data is not loaded or have server error
      if (flightResultCount.value === null || hotelResultCount.value === null) {
        return false
      }

      // If flight data is not empty, so at least one item must be selected
      if (flightResultCount.value > 0) {
        const isFlightsValid =
          !!itinerarySummaryStore.itineraries?.flight.length

        result = result && isFlightsValid
      }

      // If hotel data is not empty, so at least one item must be selected per city
      if (hotelResultCount.value > 0) {
        const itineraryCitiesCodes =
          itinerarySummaryStore.itineraries?.hotel.map((hotel) => hotel.iata) ||
          []

        const areAllCitiesSelected = curateTravelCitiesCodes.value.every(
          (cityCode) => itineraryCitiesCodes.includes(cityCode)
        )

        const isHotelsValid =
          curateTravelCitiesCodes.value.length > 0 &&
          itineraryCitiesCodes.length > 0 &&
          areAllCitiesSelected

        result = result && isHotelsValid
      }

      return result
    })

    function $reset() {
      curatedId.value = null
      searchId.value = null
      tierType.value = null
      curateTravelCitiesCodes.value = []
    }

    return {
      curatedId,
      searchId,
      tierType,
      isAllDataSelected,
      flightResultCount,
      hotelResultCount,

      setTierType,
      setSearchId,
      setCuratedId,
      setCurateTravelCitiesCodes,
      setFlightResultCount,
      setHotelResultCount,
      $reset,
    }
  },
  {
    persist: {
      storage: window.localStorage,
    },
  }
)

export default useCuratedTravelStore
